import {
  faMagnifyingGlass,
  faXmark,
} from '@awesome.me/kit-f3dc60f0d0/icons/classic/regular';
import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLingui } from '@lingui/react/macro';
import { InputAdornment, TextField } from '@mui/material';

const VideaTextField = styled(TextField)`
  width: 14em;
  & input,
  label,
  & .MuiSelect-select {
    font-size: 1em;
  }
  .MuiInputBase-root {
    height: 2.6em;
    font-size: 1em;
    padding: 0em;
  }
`;

interface SearchPracticeInputProps {
  search: string;
  setSearch: (search: string) => void;
}

export const SearchPracticeInput = ({
  search,
  setSearch,
}: SearchPracticeInputProps) => {
  const { t } = useLingui();
  return (
    <VideaTextField
      className="vai-w-[784px] vai-rounded-md vai-py-2 vai-gap-1 vai-border-1 vai-font-inter vai-font-normal  vai-text-sm"
      
      data-testid="search-practice"
      value={search}
      onChange={(e) => {
        setSearch(e.target.value);
      }}
      onKeyDown={(e) => e.stopPropagation()}
      placeholder={t`Search for location`}
      InputProps={{
        startAdornment: (
          <InputAdornment
            position="start"
            className="vai-text-base/muted-foreground vai-pl-2"
          >
            <FontAwesomeIcon icon={faMagnifyingGlass} />
          </InputAdornment>
        ),
        endAdornment: search && (
          <InputAdornment position="end" onClick={() => setSearch('')}>
            <FontAwesomeIcon
              className="vai-cursor-pointer vai-pr-2"
              icon={faXmark}
            />
          </InputAdornment>
        ),
      }}
    />
  );
};
